var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import RawAsyncValidator from "async-validator";
import { merge } from "lodash";
import { defaultValidateMessages } from "./messages";
// Remove incorrect original ts define
var AsyncValidator = RawAsyncValidator;
function replaceMessage(template, kv) {
    return template.replace(/\$\{\w+\}/g, function (str) {
        var key = str.slice(2, -1);
        return kv[key];
    });
}
function validateRule(_a) {
    var name = _a.name, value = _a.value, rule = _a.rule, options = _a.options, messageVariables = _a.messageVariables;
    return __awaiter(this, void 0, void 0, function () {
        var cloneRule, validator, messages, result, errObj_1, kv, fillVariableResult;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    cloneRule = __assign({}, rule);
                    // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    validator = new AsyncValidator((_b = {},
                        _b[name] = [cloneRule],
                        _b));
                    messages = merge({}, defaultValidateMessages, options === null || options === void 0 ? void 0 : options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.resolve(validator.validate((_c = {}, _c[name] = value, _c), __assign({}, options)))];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 4];
                case 3:
                    errObj_1 = _d.sent();
                    if (errObj_1.errors) {
                        result = errObj_1.errors.map(function (_a, index) {
                            var message = _a.message;
                            // Wrap ReactNode with `key`
                            return React.isValidElement(message)
                                ? React.cloneElement(message, { key: "error_" + index })
                                : message;
                        });
                    }
                    else {
                        // eslint-disable-next-line no-console
                        console.error(errObj_1);
                        result = [messages.default];
                    }
                    return [3 /*break*/, 4];
                case 4:
                    kv = __assign(__assign(__assign({}, rule), { name: name, enum: (rule.enum || []).join(", ") }), messageVariables);
                    fillVariableResult = result.map(function (error) {
                        if (typeof error === "string") {
                            return replaceMessage(error, kv);
                        }
                        return error;
                    });
                    return [2 /*return*/, fillVariableResult];
            }
        });
    });
}
function finishOnAllFailed(rulePromises) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.all(rulePromises).then(function (errorsList) {
                    var _a;
                    var errors = (_a = []).concat.apply(_a, errorsList);
                    return errors;
                })];
        });
    });
}
function finishOnFirstFailed(rulePromises) {
    return __awaiter(this, void 0, void 0, function () {
        var count;
        return __generator(this, function (_a) {
            count = 0;
            return [2 /*return*/, new Promise(function (resolve) {
                    rulePromises.forEach(function (promise) {
                        promise.then(function (ruleError) {
                            if (ruleError.errors.length) {
                                resolve([ruleError]);
                            }
                            count += 1;
                            if (count === rulePromises.length) {
                                resolve([]);
                            }
                        });
                    });
                })];
        });
    });
}
export function validateRules(_a) {
    var name = _a.name, value = _a.value, rules = _a.rules, options = _a.options, validateFirst = _a.validateFirst, messageVariables = _a.messageVariables;
    return __awaiter(this, void 0, void 0, function () {
        var filledRules, result, rulePromises;
        var _this = this;
        return __generator(this, function (_b) {
            filledRules = rules.map(function (rule, index) {
                var originValidatorFunc = rule.validator;
                var cloneRule = __assign(__assign({}, rule), { ruleIndex: index });
                if (originValidatorFunc) {
                    cloneRule.validator = function (rule, val, callback) {
                        var hasPromise = false;
                        // Wrap callback only accept when promise not provided
                        var wrappedCallback = function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            // Wait a tick to make sure return type is a promise
                            Promise.resolve().then(function () {
                                // console.warn(
                                //   !hasPromise,
                                //   "Your validator function has already return a promise. `callback` will be ignored."
                                // );
                                if (!hasPromise) {
                                    callback.apply(void 0, args);
                                }
                            });
                        };
                        // Get promise
                        var promise = originValidatorFunc(rule, val, wrappedCallback);
                        hasPromise = typeof (promise === null || promise === void 0 ? void 0 : promise.then) === "function" && typeof (promise === null || promise === void 0 ? void 0 : promise.catch) === "function";
                        /**
                         * 1. Use promise as the first priority.
                         * 2. If promise not exist, use callback with warning instead
                         */
                        // warning(hasPromise, "`callback` is deprecated. Please return a promise instead.");
                        if (hasPromise) {
                            promise
                                .then(function () {
                                callback();
                            })
                                .catch(function (err) {
                                callback(err || " ");
                            });
                        }
                    };
                }
                return cloneRule;
            });
            if (validateFirst) {
                result = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var i, rule, errors;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                i = 0;
                                _a.label = 1;
                            case 1:
                                if (!(i < filledRules.length)) return [3 /*break*/, 4];
                                rule = filledRules[i];
                                return [4 /*yield*/, validateRule({ name: name, value: value, rule: rule, options: options, messageVariables: messageVariables })];
                            case 2:
                                errors = _a.sent();
                                if (errors.length) {
                                    throw [{ errors: errors, rule: rule }];
                                }
                                _a.label = 3;
                            case 3:
                                i += 1;
                                return [3 /*break*/, 1];
                            case 4: return [2 /*return*/, []];
                        }
                    });
                }); })();
            }
            else {
                rulePromises = filledRules.map(function (rule) {
                    return validateRule({ name: name, value: value, rule: rule, options: options, messageVariables: messageVariables }).then(function (errors) { return ({
                        errors: errors,
                        rule: rule,
                    }); });
                });
                result = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function (errors) {
                    // Always change to rejection for Field to catch
                    return Promise.reject(errors);
                });
            }
            return [2 /*return*/, result];
        });
    });
}
